import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  UPDATE_DETAILS_REQUEST,
  UPDATE_DETAILS_SUCCESS,
  UPDATE_DETAILS_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_SUBMIT_REQUEST,
  FORGOT_PASSWORD_SUBMIT_SUCCESS,
  FORGOT_PASSWORD_SUBMIT_FAILURE,
  RESET_FORGOT_PASSWORD_FLAG,
  CLEAR_SESSION_ERROR,
  SET_CHALLENGE,
} from "actions/session";

const initialState = {
  loading: false,
  session: undefined,
  error: {},
  codeSent: "",
  challenge: "",
};

export default function session(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOGIN_REQUEST:
    case CHANGE_PASSWORD_REQUEST:
    case LOGOUT_REQUEST:
    case UPDATE_DETAILS_REQUEST:
    case FORGOT_PASSWORD_REQUEST:
    case FORGOT_PASSWORD_SUBMIT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: {},
      };
    }

    case LOGIN_SUCCESS:
    case CHANGE_PASSWORD_SUCCESS:
    case UPDATE_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        session: payload.signInUserSession,
      };
    }

    case FORGOT_PASSWORD_SUCCESS: {
      return {
        ...state,
        loading: false,
        codeSent: "resetPassword",
      };
    }

    case FORGOT_PASSWORD_SUBMIT_SUCCESS: {
      return {
        ...state,
        loading: false,
        codeSent: "",
      };
    }

    case RESET_FORGOT_PASSWORD_FLAG: {
      return {
        ...state,
        codeSent: "",
      };
    }

    case LOGOUT_SUCCESS:
    case LOGOUT_FAILURE: {
      return {
        ...state,
        ...initialState,
        loading: false,
      };
    }

    case LOGIN_FAILURE:
    case CHANGE_PASSWORD_FAILURE:
    case UPDATE_DETAILS_FAILURE:
    case FORGOT_PASSWORD_FAILURE:
    case FORGOT_PASSWORD_SUBMIT_FAILURE: {
      return {
        ...state,
        loading: false,
        session: undefined,
        challenge: undefined,
        error: {
          ...payload,
          message: payload?.message || "Something went wrong",
        },
      };
    }

    case CLEAR_SESSION_ERROR: {
      return {
        ...state,
        error: {},
      };
    }

    case SET_CHALLENGE: {
      return {
        ...state,
        challenge: payload,
        loading: false,
      };
    }

    default:
      return state;
  }
}
